
import '../App.css';
import logo from '../images/logo.jpg';
import { useNavigate } from "react-router-dom";
export default function Header() {
    const navigate = useNavigate();
    return (
        <div className='headerMainDiv'>
            <div className='headerLeftDiv'>
                <a href="/"><img src={logo} alt="Logo" /></a>
            </div>
            <div className='headerMidDiv'>
                <div className='logo' >
                    <a href="/"><img src={logo} alt="Logo" /></a>
                </div>
                <div className='headerTitleDiv'>
                <h1 className='enHeaderTitle'>Sudanese Sociality Association</h1>
                <h1 className='arHeaderTitle'> الجمعية السودانية الإجتماعية</h1>
                <h2 className='headerSubTitle'>Cedar Rapids, Iowa, United States</h2>
                <div className='menuDiv'>
                    <button onClick={() => navigate('/login')}>Login</button>
                    <button onClick={() => navigate('/dashboard')}>Members</button>
                </div>
                </div>
            </div>
            <div className='headerRightDiv'>
                <img src={logo} alt="Logo" />
            </div>
        </div>
    )
}